import { useCallback } from 'react';
import { Flex, RemoteImage, Switch, Typography } from '@banhala/ui-kit';
import type { HeadlineXsmallOneLineToggleProps } from './types';
import { bridge, isNil, isNotNil } from '../../../../utils';
import type { IScreensLogging } from '../../../../api/types';
import { useFilterListAtom } from '../../ItemList/FilterList/Provider/filterList/useFilterListAtom';

export const HeadlineXsmallOneLineToggle = ({
  header,
  scrollToFilterList,
}: HeadlineXsmallOneLineToggleProps) => {
  const { setFilterListAtom } = useFilterListAtom();

  const handleToggle = useCallback(
    (nextValue: boolean) => {
      if (isNil(header)) return;

      logClickToggle({ logging: header.logging, isOn: nextValue });

      scrollToFilterList?.();
      setFilterListAtom(prev => ({
        ...prev,
        [header.item.query_name]: nextValue
          ? [header.item.query_value]
          : undefined,
      }));
    },
    [header, scrollToFilterList, setFilterListAtom],
  );

  if (isNil(header)) return null;

  return (
    <Flex.Row
      padding={{ top: 16, bottom: 12, horizontal: 16 }}
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography type="subtitle1" color="content_primary">
        {header.item.title}
      </Typography>
      <Flex.Row alignItems="center" gap={8}>
        {isNotNil(header.item.image) && (
          <RemoteImage
            uri={header.item.image}
            width={50}
            height={20}
            resizeMode="contain"
          />
        )}
        <Switch value={header.item.is_on} onChange={handleToggle} />
      </Flex.Row>
    </Flex.Row>
  );
};

const logClickToggle = ({
  logging,
  isOn,
}: {
  logging: IScreensLogging;
  isOn: boolean;
}) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_XSMALL_ONE_LINE_TOGGLE',
    analytics: { ...logging.analytics, IS_ON: isOn },
    ably_only_log: logging.ably_only_log,
  });
};
